<template>
  <div class="agreement" :class="{ wide: isWideScreen }">
    <div class="ag-header">
      <div class="brand">影传</div>
      <h1 class="ag-title">用户协议</h1>
      <div class="ag-meta">
        <span>生效日期：2026年8月29日</span>
      </div>
    </div>

    <div class="ag-body">
      <section class="sec">
        <h2>一、总则</h2>
        <p>欢迎使用"影传"（以下简称"本应用"）。在使用本应用前，请您仔细阅读并充分理解本协议的全部内容。</p>
        <p>本协议是您与本应用开发方之间就本应用的使用所订立的协议。一旦您下载、访问或使用本应用，即视为您已阅读、理解并同意接受本协议的全部条款。若您不同意本协议的任何内容，请勿使用本应用。</p>
      </section>

      <section class="sec">
        <h2>二、服务说明</h2>
        <p>本应用是一款用于连接相机与移动设备、进行照片与视频传输、浏览与整理的工具，核心功能包括：</p>
        <ol class="circle">
          <li>通过局域网或直连Wifi方式发现并连接您的相机设备；</li>
          <li>将相机中的照片、视频预览与下载到您的移动设备；</li>
          <li>在设备本地对照片进行浏览、筛选、整理与清理；</li>
        </ol>
        <p>上述识别、整理等处理主要在<strong>您的设备本地完成</strong>。任何内容都不会上传至云端。</p>
      </section>

      <section class="sec">
        <h2>三、设备权限</h2>
        <p>为提供核心功能，本应用会在您授权后访问以下设备资源：</p>
        <ol class="num">
          <li>本地网络：用于发现并连接同一网络下的相机设备；</li>
          <li>相册 / 存储：用于将传输的照片保存至您的设备，并读取相册用于整理；</li>
          <li>通知：用于传输完成、备份状态等必要的服务提醒。</li>
        </ol>
        <p>您可随时在设备系统设置中关闭上述权限；关闭后相关功能可能无法正常使用，但不会影响其他功能。</p>
      </section>

      <section class="sec">
        <h2>四、数据收集与使用</h2>
        <p>我们高度重视您的隐私，数据处理原则如下：</p>
        <ol class="num">
          <li>您的照片、视频等原始内容默认仅保存在您自己的设备本地，<strong>不会默认上传至服务器</strong>；</li>
          <li>为定位与修复问题，我们可能收集设备型号、系统版本、应用版本与匿名化运行日志；</li>
          <li>更详细的信息处理说明，请参阅《影传用户隐私政策》。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>五、内购与付费说明</h2>
        <ol class="num">
          <li>本应用提供内购项目（如增值功能或会员），具体以购买页面展示为准；</li>
          <li>您通过{{ brand }}应用内购买（IAP）完成支付，支付成功后方可使用对应权益；</li>
          <li>退款相关事宜依据{{ brand }}应用市场规则处理。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>六、知识产权</h2>
        <ol class="num">
          <li>本应用及其相关商标、著作权、技术文档等知识产权归开发方所有，受法律保护；</li>
          <li>您使用本应用所传输、整理的照片与视频，其知识产权归您或相关权利人所有；</li>
          <li>未经许可，您不得对本应用进行反向工程、破解、二次分发或用于商业用途。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>七、免责声明</h2>
        <ol class="num">
          <li>因相机兼容性、网络环境、设备状态等因素，本应用不保证对所有设备与场景均完全适配；</li>
          <li>建议您在执行删除、覆盖等不可逆操作前自行确认，因误操作导致的数据丢失本应用不承担责任；</li>
          <li>因不可抗力或第三方服务（如{{ brand }}应用市场、相机厂商）原因导致服务中断，本应用不承担责任。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>八、协议变更</h2>
        <ol class="num">
          <li>本应用有权根据法律法规变化或业务需要修改本协议内容；</li>
          <li>修改后的协议将在应用内公示，若您在协议修改后继续使用本应用，视为同意修改后的协议；</li>
          <li>如您不同意修改后的协议，请停止使用本应用。</li>
        </ol>
      </section>

      <section class="sec">
        <h2>九、其他</h2>
        <ol class="num">
          <li>本协议的订立、执行和解释均适用中华人民共和国法律；</li>
          <li>本协议未尽事宜，按照相关法律法规执行；</li>
          <li>如您对本协议有任何疑问，请通过电子邮件 <a class="ag-mail" href="mailto:support@capturedslr.cc">support@capturedslr.cc</a> 与我们联系。</li>
        </ol>
      </section>

      <div class="ag-contact">联系我们：<a class="ag-mail" href="mailto:support@capturedslr.cc">support@capturedslr.cc</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "yingchuanUserAgreement",
  props: {
    isWideScreen: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    isIOS() {
      const q = (this.$route && this.$route.query) || {};
      const v = (q.os || q.platform || "").toString().toLowerCase();
      return v === "ios";
    },
    brand() {
      return this.isIOS ? "苹果" : "华为";
    },
  },
};
</script>

<style scoped>
.agreement {
  background: #fff;
  text-align: left;
  color: #1f2933;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
    "Helvetica Neue", Arial, sans-serif;
  line-height: 1.85;
  font-size: 16px;
  margin: 0 auto;
  max-width: 860px;
  padding: 24px 16px 48px;
}
.agreement.wide {
  padding: 36px 28px 56px;
  margin-top: 20px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.ag-header {
  background: linear-gradient(135deg, #60a5fa, #3b82f6);
  color: #fff;
  text-align: center;
  padding: 32px 16px 26px;
  border-radius: 10px 10px 0 0;
  margin: -24px -16px 0;
}
.agreement.wide .ag-header {
  margin: -36px -28px 0;
}
.ag-header .brand {
  font-size: 0.95rem;
  letter-spacing: 0.18em;
  opacity: 0.92;
  margin-bottom: 8px;
}
.ag-title {
  font-size: 1.7rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: 0.04em;
}
.ag-meta {
  margin-top: 12px;
  font-size: 0.9rem;
  opacity: 0.9;
}
.sec {
  margin-top: 28px;
}
.sec h2 {
  font-size: 1.12rem;
  color: #3b82f6;
  margin: 0 0 12px;
  padding-left: 0.6em;
  border-left: 4px solid #3b82f6;
  line-height: 1.5;
}
.sec p {
  margin: 0.6em 0;
}
ol.num {
  list-style: decimal;
  padding-left: 1.6em;
  margin: 0.6em 0;
}
ol.num > li {
  margin: 0.45em 0;
  padding-left: 0.2em;
}
ol.circle {
  list-style: none;
  counter-reset: c;
  padding-left: 1.7em;
  margin: 0.6em 0;
}
ol.circle > li {
  counter-increment: c;
  position: relative;
  margin: 0.45em 0;
}
ol.circle > li::before {
  content: "（" counter(c) "）";
  position: absolute;
  left: -1.7em;
  color: #3b82f6;
  font-weight: 600;
}
.ag-note {
  margin-top: 26px;
  padding: 14px 16px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  color: #6b7280;
  font-size: 0.88rem;
}
.ag-contact {
  margin-top: 18px;
  padding: 14px 16px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  color: #1d4ed8;
  font-size: 0.95rem;
  text-align: center;
}
.ag-mail {
  color: #2563eb;
  text-decoration: none;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/agreements/yingchuan/user-agreement.vue